/* eslint-disable */
import settings from "../../../configs/settings";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/system";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SearchIcon from "@mui/icons-material/Search";
import SavedSearchIcon from "@mui/icons-material/SavedSearch";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useContext, useState } from "react";
import GestionAtencionContext from "../../../project/contexts/GestionAtencionContext";
import BuscarServicioDialog from "./BuscarServicioDialog";
import { getServicio } from "../../../project/services/ServicioService";
import Message from "../../../project/utils/Message";
import { formatMoney } from "../../utils/utils"
import { limpiaCodigo } from "../../utils/utils";
import WaitingDialog from "../../utils/WaitingDialog";

//
// ################################################################################
//
const ArregloServicios = () => {
  const [openDialogBusquedaAvanzada, setOpenDialogBusquedaAvanzada] = useState(false);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [disabledServicios, setDisabledServicios] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const {
    initialArregloServicio,
    arregloServicio,
    handleChangeArregloServicio,
    setArregloServicio,
    arregloServiciosRows,
    setArregloServiciosRows,
    totalArregloServicios,
    totalArregloServiciosContado,
    gaAction,
  } = useContext(GestionAtencionContext);
  let {
    arregloServicioCodigo,
    arregloServicioDescripcion,
    arregloServicioPrecioVenta,
    arregloServicioPrecioVentaContado,
    arregloServicioCantidad,
    arregloServicioSubtotal,
    arregloServicioSubtotalContado,
  } = arregloServicio;

  const tableColumns = [
    {
      field: "arregloServicioCodigo",
      headerName: "Código",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioCodigo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloServicioDescripcion",
      headerName: "Servicio",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioDescripcion;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "arregloServicioPrecioVenta",
      headerName: "Prc Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioPrecioVenta.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "arregloServicioPrecioVentaContado",
      headerName: "Prc Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioPrecioVentaContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "arregloServicioCantidad",
      headerName: "Cant",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioCantidad;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "arregloServicioSubtotal",
      headerName: "Sub Lista",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioSubtotal.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "arregloServicioSubtotalContado",
      headerName: "Sub Contado",
      headerAlign: "center",
      align: "right",
      flex: 1,
      type: "number",
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.arregloServicioSubtotalContado.toFixed(2);
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {gaAction.cu !== "view" && (
            <Tooltip title="quitar servicio">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => handleClickActionServicio(params.row)}
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  const handleClickActionServicio = (parRow) => {
    if (parRow === undefined) {
      // si estoy agregando un servicio

      if (arregloServicioCodigo === "" || arregloServicioDescripcion === "") {
        setMessage({
          messageText: "Debes seleccionar un servicio",
          severity: "error",
        });
        setShowMessage(true);
        return;
      }

      let _servicio = {
        id: uuidv4(),
        arregloServicioId: arregloServicio.arregloServicioId,
        arregloServicioCodigo: arregloServicio.arregloServicioCodigo,
        arregloServicioDescripcion: arregloServicio.arregloServicioDescripcion,
        arregloServicioPrecioVenta: arregloServicio.arregloServicioPrecioVenta,
        arregloServicioPrecioVentaOriginal: arregloServicio.arregloServicioPrecioVentaOriginal,
        arregloServicioPorcentajeDescuento: arregloServicio.arregloServicioPorcentajeDescuento,
        arregloServicioPrecioVentaContado: arregloServicio.arregloServicioPrecioVentaContado,
        arregloServicioCantidad: arregloServicio.arregloServicioCantidad,
        arregloServicioSubtotal: arregloServicio.arregloServicioSubtotal,
        arregloServicioSubtotalContado: arregloServicio.arregloServicioSubtotalContado,
      };
      setArregloServiciosRows([...arregloServiciosRows, _servicio]);
      setArregloServicio(initialArregloServicio);
    } else {
      // si estoy eliminando un servicio

      let _ServiciosRows = arregloServiciosRows.filter(
        (item) => item.id !== parRow.id
      );
      setArregloServiciosRows(_ServiciosRows);
    }
  };
  //
  // ################################################################################
  //
  const handleBuscarServicio = () => {
    if (arregloServicioCodigo === "") {
      return;
    }

    const buscarServicio = async () => {

      const _arregloServicioCodigo = limpiaCodigo(arregloServicioCodigo).toUpperCase();

      setIsDoingSomething(true);
      const response = await getServicio(_arregloServicioCodigo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _servicio = {
          arregloServicioId: response.data.data[0].id,
          arregloServicioCodigo: response.data.data[0].codigo,
          arregloServicioDescripcion: response.data.data[0].descripcion,
          arregloServicioPrecioVenta: response.data.data[0].precio_venta_lista,
          arregloServicioPrecioVentaOriginal: response.data.data[0].precio_venta_lista,
          arregloServicioPorcentajeDescuento: 0,
          arregloServicioPrecioVentaContado: response.data.data[0].precio_venta_lista,
          arregloServicioCantidad: 1,
          arregloServicioSubtotal: response.data.data[0].precio_venta_lista,
          arregloServicioSubtotalContado: response.data.data[0].precio_venta_lista,
        };
        setArregloServicio(_servicio);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
        setArregloServicio(initialArregloServicio);
      }
    };

    buscarServicio();
  };
  //
  // ################################################################################
  //
  const handleClickOpenBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(true);
  };
  //
  // ################################################################################
  //
  const handleCloseBusquedaAvanzada = () => {
    setOpenDialogBusquedaAvanzada(false);
  };
  //
  // ################################################################################
  //
  const handleSelectBusquedaAvanzada = (articulo) => {
    setOpenDialogBusquedaAvanzada(false);

    let _servicio = {
      arregloServicioId: articulo.id,
      arregloServicioCodigo: articulo.codigo,
      arregloServicioDescripcion: articulo.descripcion,
      arregloServicioPrecioVenta: articulo.precio_venta_lista,
      arregloServicioPrecioVentaOriginal: articulo.precio_venta_lista,
      arregloServicioPorcentajeDescuento: 0,
      arregloServicioPrecioVentaContado: articulo.precio_venta_lista,
      arregloServicioCantidad: 1,
      arregloServicioSubtotal: articulo.precio_venta_lista,
      arregloServicioSubtotalContado: articulo.precio_venta_lista,
    };
    setArregloServicio(_servicio);
  };
  //
  // ################################################################################
  //
  const handleLimpiarServicio = () => {
    setArregloServicio(initialArregloServicio);
  };
  //
  // ################################################################################
  //
  const handleBlur = (e) => {
    let _cantidad = e.target.value;
    _cantidad =
      _cantidad === "" || isNaN(_cantidad) || parseInt(+_cantidad) <= 0 ? 1 : parseInt(+_cantidad);
    let _subtotal = _cantidad * arregloServicioPrecioVenta;
    let _subtotalContado = _cantidad * arregloServicioPrecioVentaContado;
    setArregloServicio({
      ...arregloServicio,
      arregloServicioCantidad: _cantidad,
      arregloServicioSubtotal: _subtotal,
      arregloServicioSubtotalContado: _subtotalContado,
    });
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box sx={{ mx: 1, px: 1, pb: 1 }}>
        {gaAction.cu !== "view" && (
          <>
            <Box>
              <Grid container spacing={1}>
                <Grid item md={6}>
                  {/* codigo de servicio */}

                  <TextField
                    sx={{ mb: 1 }}
                    id="codigo-servicio"
                    label="Código del Servicio"
                    variant="outlined"
                    size="small"
                    name="arregloServicioCodigo"
                    value={arregloServicioCodigo}
                    onChange={handleChangeArregloServicio}
                    disabled={arregloServicioDescripcion !== "" || disabledServicios}
                  />
                </Grid>

                <Grid item md={6}>
                  {/* boton buscar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleBuscarServicio}
                    startIcon={<SearchIcon />}
                    disabled={arregloServicioCodigo === "" || arregloServicioDescripcion !== ""}
                  >
                    Buscar
                  </Button>

                  {/* boton busqueda avanzada */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    onClick={handleClickOpenBusquedaAvanzada}
                    startIcon={<SavedSearchIcon />}
                    disabled={disabledServicios}
                  >
                    Búsqueda Avanzada
                  </Button>

                  {/* boton limpiar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="outlined"
                    onClick={handleLimpiarServicio}
                    startIcon={<CleaningServicesIcon />}
                    disabled={arregloServicioCodigo === ""}
                  >
                    Limpiar
                  </Button>
                </Grid>
              </Grid>

              <Grid container spacing={1}>
                <Grid item xs={12} md={6} sx={{ mb: 1 }}>
                  {/* descripcion del armazon */}

                  <TextField
                    sx={{ width: "100%" }}
                    id="arregloServicioDescripcion"
                    label="Descripción"
                    variant="outlined"
                    size="small"
                    name="arregloServicioDescripcion"
                    value={arregloServicioDescripcion}
                    disabled
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de lista */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloServicioPrecioVenta"
                    label="Precio de lista"
                    variant="outlined"
                    size="small"
                    name="arregloServicioPrecioVenta"
                    value={arregloServicioPrecioVenta.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* precio de contado */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloServicioPrecioVentaContado"
                    label="Precio de contado"
                    variant="outlined"
                    size="small"
                    name="arregloServicioPrecioVentaContado"
                    value={arregloServicioPrecioVentaContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* cantidad */}

                  <TextField
                    sx={{ width: "40%" }}
                    inputProps={{ style: { textAlign: "center" } }}
                    id="arregloServicioCantidad"
                    label="Cantidad"
                    variant="outlined"
                    size="small"
                    name="arregloServicioCantidad"
                    value={arregloServicioCantidad}
                    onChange={handleChangeArregloServicio}
                    onBlur={handleBlur}
                    disabled={arregloServicioCodigo === ""}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* subtotal de lista */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloServicioSubtotal"
                    label="Sub Lista"
                    variant="outlined"
                    size="small"
                    name="arregloServicioSubtotal"
                    value={arregloServicioSubtotal.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>

                <Grid item xs={12} md={2} sx={{ mb: 1 }}>
                  {/* subtotal de contado */}

                  <TextField
                    sx={{ width: "70%" }}
                    inputProps={{ style: { textAlign: "right" } }}
                    id="arregloServicioSubtotalContado"
                    label="Sub Contado"
                    variant="outlined"
                    size="small"
                    name="arregloServicioSubtotalContado"
                    value={arregloServicioSubtotalContado.toLocaleString(
                      settings.numericLocales.language,
                      settings.numericLocales.options
                    )}
                    disabled={true}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
                  {/* boton agregar */}

                  <Button
                    sx={{ mr: 1 }}
                    variant="contained"
                    disabled={
                      disabledServicios ||
                      arregloServicioCodigo === "" ||
                      arregloServicioDescripcion === ""
                    }
                    onClick={() => handleClickActionServicio()}
                    startIcon={<AddCircleOutlineOutlinedIcon />}
                  >
                    Agregar
                  </Button>
                </Grid>
              </Grid>
            </Box>
          </>
        )}

        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ mr: 2, mb: 1 }}>
            <DataGrid
              rows={arregloServiciosRows}
              columns={tableColumns}
              {...tableOptions}
            />
          </Grid>

          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE LISTA: {formatMoney(totalArregloServicios)}
            </Typography>
          </Grid>
          <Grid item sm={6}>
            <Typography
              component="div"
              align="right"
              sx={{
                p: 1,
                mt: 2,
                backgroundColor: "LightBlue",
                borderRadius: "5px",
                fontWeight: "bold",
              }}
            >
              PRECIO DE CONTADO: {formatMoney(totalArregloServiciosContado)}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      {openDialogBusquedaAvanzada && (
        <BuscarServicioDialog
          open={openDialogBusquedaAvanzada}
          onClose={handleCloseBusquedaAvanzada}
          onSelect={handleSelectBusquedaAvanzada}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default ArregloServicios;